import { parse } from 'path';

/* return spread number type */
export function spreadNumber(num, spread, mark) {
    let roundNum = Math.round(num);
    let finalNumber = [];
    let virtualNumber;
    let i = (roundNum + "").length;
    while (true) {
        virtualNumber = (roundNum + "").substring(i - spread, i);
        i -= spread;
        if (virtualNumber !== "")
            finalNumber.push(virtualNumber);
        else
            break;
    }
    return finalNumber.reverse().join(mark).trim(mark);
}

// thousand separator
export const moneyFormatter = number => {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// truncated text
export function truncateText(selector, maxLength, truncate) {
    let truncated = selector;
    if (truncated.length > maxLength) {
        truncated = truncated.substr(0, maxLength) + (truncate ?? '...');
    }
    return truncated;
}

// model string formater
export const spliterCharacter = "{^}"
export const decodeModelString = string => {
    if (!string) return string
    const splitedCharacter = string?.split(spliterCharacter)
    if (splitedCharacter.length !== 3) return string

    return ({
        title: decodeURI(splitedCharacter[0]),
        picUrl: decodeURI(splitedCharacter[1]),
        value: decodeURI(splitedCharacter[2])
    })
}

export const encodeModelString = props => {
    const { title, picUrl, value } = props
    return (
        encodeURI(title) +
        spliterCharacter +
        encodeURI(picUrl) +
        spliterCharacter +
        encodeURI(value)
    )
}

// detect link in a string
export function URLReplacer(str) {
    let match = str?.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig)
    let final = str
    match?.map(url => {
        final = final.replace(url, "<a href=\"" + url + "\" target=\"_BLANK\">" + url + "</a>")
    })
    return final
}

// scroll to top
export function scrollToTop(top, closeScrollUp) {
    if (!closeScrollUp && window && typeof window !== "undefined") {
        window.scrollTo({
            top: top ?? 0,
            behavior: "smooth"
        })
    }
}

export function haveToken() {
    if (typeof window !== "undefined") {
        return Boolean(localStorage.getItem("token"))
    }
}

// change order in array
export function arrayMove(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
}



const ACCEPTABLE_IMAGE_FILE_EXTENSIONS = [
    '.jpg',
    '.png',
    '.jpeg',
    '.svg',
    '.webp',
];

export function addThumbnailPostfixToImageName(fileName) {
    const p = parse(fileName);
    if (ACCEPTABLE_IMAGE_FILE_EXTENSIONS.includes(p.ext)) {
        const newFileName = p.name + '-thumb' + p.ext;
        if (p.dir) return p.dir + '/' + newFileName;
        else return newFileName;
    } else return fileName + '-thumb.webp';
}

export const removeObjectNullish = (object) => {
    Object
        .entries(object)
        .forEach(([k, v]) => {
            if (v && typeof v === 'object')
                removeObjectNullish(v);
            if (v &&
                typeof v === 'object' &&
                !Object.keys(v).length ||
                v === null ||
                v === undefined ||
                v.length === 0
            ) {
                if (Array.isArray(object))
                    object.splice(k, 1);
                else if (!(v instanceof Date))
                    delete object[k];
            }
        });
    return object;
}

export const ratingColor = number => {
    if (number <= 1) return "#F9BC00"
    else if (number <= 2) return "#B1B64D"
    else if (number <= 3) return "#65AA57"
    return "#00A049"
}